import { c as _c } from "react/compiler-runtime";
import { Command, Menu, Search } from "lucide-react";
import * as React from "react";
import { cn } from "@/utils/cn";
interface InputProps extends React.ComponentProps<"input"> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  showKeyboardShortcut?: boolean;
  keyboardShortcut?: string;
}
function Input(t0) {
  const $ = _c(30);
  let className;
  let endIcon;
  let props;
  let showKeyboardShortcut;
  let startIcon;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      startIcon,
      endIcon,
      showKeyboardShortcut,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = endIcon;
    $[3] = props;
    $[4] = showKeyboardShortcut;
    $[5] = startIcon;
    $[6] = type;
  } else {
    className = $[1];
    endIcon = $[2];
    props = $[3];
    showKeyboardShortcut = $[4];
    startIcon = $[5];
    type = $[6];
  }
  if (startIcon || endIcon || showKeyboardShortcut) {
    let t1;
    if ($[7] !== startIcon) {
      t1 = startIcon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">{startIcon}</div>;
      $[7] = startIcon;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    const t2 = startIcon ? "pl-10" : "pl-3";
    const t3 = endIcon || showKeyboardShortcut ? "pr-16" : "pr-3";
    let t4;
    if ($[9] !== className || $[10] !== t2 || $[11] !== t3) {
      t4 = cn("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", t2, t3, className);
      $[9] = className;
      $[10] = t2;
      $[11] = t3;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    let t5;
    if ($[13] !== props || $[14] !== t4 || $[15] !== type) {
      t5 = <input type={type} data-slot="input" className={t4} {...props} />;
      $[13] = props;
      $[14] = t4;
      $[15] = type;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== endIcon || $[18] !== showKeyboardShortcut) {
      t6 = (endIcon || showKeyboardShortcut) && <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2">{showKeyboardShortcut && <div className="flex items-center gap-1 text-xs text-muted-foreground"><kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100"><Command className="size-3" /></kbd><kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">S</kbd></div>}{endIcon && <div className="text-muted-foreground">{endIcon}</div>}</div>;
      $[17] = endIcon;
      $[18] = showKeyboardShortcut;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    let t7;
    if ($[20] !== t1 || $[21] !== t5 || $[22] !== t6) {
      t7 = <div className="relative">{t1}{t5}{t6}</div>;
      $[20] = t1;
      $[21] = t5;
      $[22] = t6;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    return t7;
  }
  let t1;
  if ($[24] !== className) {
    t1 = cn("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", className);
    $[24] = className;
    $[25] = t1;
  } else {
    t1 = $[25];
  }
  let t2;
  if ($[26] !== props || $[27] !== t1 || $[28] !== type) {
    t2 = <input type={type} data-slot="input" className={t1} {...props} />;
    $[26] = props;
    $[27] = t1;
    $[28] = type;
    $[29] = t2;
  } else {
    t2 = $[29];
  }
  return t2;
}

// Search Input - matches mood board
interface SearchInputProps extends Omit<InputProps, "type" | "startIcon"> {
  onClear?: () => void;
}
function SearchInput(t0) {
  const $ = _c(13);
  let endIcon;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      placeholder: t1,
      showKeyboardShortcut: t2,
      endIcon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = endIcon;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    endIcon = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const placeholder = t1 === undefined ? "Search..." : t1;
  const showKeyboardShortcut = t2 === undefined ? true : t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Search className="size-4" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== endIcon) {
    t4 = endIcon || <Menu className="size-4" />;
    $[6] = endIcon;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== placeholder || $[9] !== props || $[10] !== showKeyboardShortcut || $[11] !== t4) {
    t5 = <Input type="search" placeholder={placeholder} startIcon={t3} showKeyboardShortcut={showKeyboardShortcut} endIcon={t4} {...props} />;
    $[8] = placeholder;
    $[9] = props;
    $[10] = showKeyboardShortcut;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export { Input, SearchInput };